/* ============================================================
   Rabbit0 Studio — カスタムJS（Dawn重ね用）
   各セクションを初期化。1ファイルで全機能をカバー。
============================================================ */
(function(){
  'use strict';

  // ---------- HERO slider ----------
  document.querySelectorAll('.forge-hero').forEach(function(hero){
    var slides=[].slice.call(hero.querySelectorAll('.slide'));
    var dots=[].slice.call(hero.querySelectorAll('.dots button'));
    if(slides.length<2)return;
    var i=0,t=null;
    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function go(n){i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('on',k===i)});
      dots.forEach(function(d,k){d.classList.toggle('on',k===i)});}
    function start(){if(reduce)return;stop();t=setInterval(function(){go(i+1)},5000)}
    function stop(){if(t)clearInterval(t)}
    dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.g);start()})});
    hero.addEventListener('mouseenter',stop);
    hero.addEventListener('mouseleave',start);
    start();
  });

  // ---------- FAQ accordion ----------
  document.querySelectorAll('.forge-faq .q').forEach(function(q){
    q.addEventListener('click',function(){q.closest('.item').classList.toggle('open')});
  });

  // ---------- sidebar category accordion ----------
  document.querySelectorAll('.scat .toggle').forEach(function(b){
    b.addEventListener('click',function(e){
      e.preventDefault();
      b.closest('li').classList.toggle('open');
    });
  });

  // ---------- LOAN simulator (add-on method) ----------
  // data-forge-loan に対象を置く。価格は data-price 属性 or #forge-loan-price 入力。
  document.querySelectorAll('[data-forge-loan]').forEach(function(root){
    var ADDON=parseFloat(root.dataset.addon||'0.007');   // アドオン率 0.7%
    var MIN=parseInt(root.dataset.minMonthly||'3000',10); // 最低月額
    var priceInput=root.querySelector('.f-loan-price');
    var down=root.querySelector('.f-loan-down');
    var months=root.querySelector('.f-loan-months');
    var fixedPrice=root.dataset.price?parseInt(root.dataset.price,10):null;
    function fmt(n){return '¥'+Math.round(n).toLocaleString()}
    function num(el){return el?parseInt((el.value||'0').replace(/[^0-9]/g,''),10)||0:0}
    function calc(){
      var total=fixedPrice!==null?fixedPrice:num(priceInput);
      // 商品ページで window.FORGE_PRICE があれば優先（オプション連動）
      if(root.dataset.live==='true'&&window.FORGE_PRICE)total=window.FORGE_PRICE;
      var d=num(down); if(d>total)d=total;
      var m=parseInt(months.value,10);
      var apply=Math.max(0,total-d);
      var fee=Math.round(apply*ADDON*m);
      var payTotal=apply+fee;
      var monthly=Math.ceil(payTotal/m);
      if(monthly<MIN&&apply>0)monthly=MIN;
      var set=function(sel,val){var el=root.querySelector(sel);if(el)el.innerHTML=val};
      set('.f-loan-apply',fmt(apply));
      set('.f-loan-fee',fmt(fee));
      set('.f-loan-total',fmt(payTotal));
      set('.f-loan-monthly',fmt(monthly)+'<small> ×'+m+'回</small>');
      if(priceInput&&fixedPrice===null&&root.dataset.live==='true')priceInput.value=total;
    }
    if(priceInput)priceInput.addEventListener('input',calc);
    if(down)down.addEventListener('input',calc);
    if(months)months.addEventListener('change',calc);
    root._forgeCalc=calc; // 外部から再計算できるように
    calc();
  });

  // ---------- CARD installments simulator ----------
  document.querySelectorAll('[data-forge-cardsim]').forEach(function(root){
    var MIN=10000;
    var brand=root.querySelector('.f-cs-brand');
    var count=root.querySelector('.f-cs-count');
    var out=root.querySelector('.f-cs-monthly');
    var priceInput=root.querySelector('.f-cs-price');
    var fixedPrice=root.dataset.price?parseInt(root.dataset.price,10):null;
    function fmt(n){return '¥'+Math.round(n).toLocaleString()}
    function getTotal(){
      if(priceInput)return parseInt((priceInput.value||'0').replace(/[^0-9]/g,''),10)||0;
      if(fixedPrice!==null)return fixedPrice;
      return window.FORGE_PRICE||0;
    }
    function buildCounts(){
      var max=parseInt(brand.value,10);
      var prev=parseInt(count.value,10)||1;
      count.innerHTML='';
      [1,3,5,6,10,12,15,18,20,24,30,36,48,60].filter(function(n){return n<=max}).forEach(function(n){
        var o=document.createElement('option');o.value=n;o.textContent=(n===1?'一括払い':n+'回払い');count.appendChild(o);
      });
      count.value=(prev<=max?prev:max);
    }
    function calc(){
      var total=getTotal();
      var n=parseInt(count.value,10)||1;
      if(n<=1){out.innerHTML=fmt(total)+'<small>（一括）</small>';return}
      if(total<MIN){out.innerHTML='<small style="font-size:13px;color:#6b7280">分割は¥10,000以上から</small>';return}
      out.innerHTML=fmt(Math.ceil(total/n))+'<small> ×'+n+'回</small>';
    }
    brand.addEventListener('change',function(){buildCounts();calc()});
    count.addEventListener('change',calc);
    if(priceInput)priceInput.addEventListener('input',calc);
    root._forgeCalc=calc;
    buildCounts();calc();
  });

  // 商品ページ用：価格が変わったら全シミュレーターを再計算するヘルパ
  window.forgeRefreshSimulators=function(){
    document.querySelectorAll('[data-forge-loan],[data-forge-cardsim]').forEach(function(r){
      if(r._forgeCalc)r._forgeCalc();
    });
  };
})();

// 商品レールの矢印スクロール
(function(){
  document.querySelectorAll('.rail-wrap').forEach(function(wrap){
    var rail=wrap.querySelector('.forge-rail');
    var prev=wrap.querySelector('[data-rail-prev]');
    var next=wrap.querySelector('[data-rail-next]');
    if(!rail)return;
    function amt(){return Math.max(rail.clientWidth*0.8,200)}
    if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-amt(),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){rail.scrollBy({left:amt(),behavior:'smooth'})});
    function upd(){
      var max=rail.scrollWidth-rail.clientWidth-2;
      if(prev)prev.classList.toggle('hide',rail.scrollLeft<=2);
      if(next)next.classList.toggle('hide',rail.scrollLeft>=max);
    }
    rail.addEventListener('scroll',upd);window.addEventListener('resize',upd);upd();
  });
})();
